export default __webpack_public_path__ + "static/media/Anger.6b1afdb7.svg";